import { createSelector } from "@reduxjs/toolkit";
import { formatChartData } from "../../components/chart/utils";
import { selectChartScope } from "../utils/scopedChartDataUtils";

export const selectSensorAverageState = (state, scope) =>
  selectChartScope(state.sensorAverageData, scope);

export const selectRawAverageData = (state, scope) =>
  selectSensorAverageState(state, scope).data;

export const selectSensorAverageIsLoading = (state, scope) =>
  selectSensorAverageState(state, scope).isLoading;

export const selectFormattedAverageData = createSelector(
  [selectRawAverageData],
  (rawData) => {
    if (!rawData || Object.keys(rawData).length === 0) {
      return [];
    }
    return formatChartData(rawData);
  }
);
